import React from 'react';
import {
    Header,
    Footer,
} from '@usb-onboarding/product-recommender-components';
import NotFound from '../../molecules/NotFound';

function NotFoundPage() {
    return (
        <>
            <Header />
            <main id="app__content">
                <NotFound />
            </main>
            <Footer
                privacyUrl="https://www.usbank.com/about-us-bank/privacy/privacy-pledge.html"
                fdic=""
            />
        </>
    );
}

export default NotFoundPage;
